import { Alert } from '@treezor/design-system';

import { useCallback } from 'react';

import { useRoutepaths } from '@/router/hooks/useRoutePaths';

import { useAlert } from './useAlert';

export function ScopesAlert({ scopes }: { scopes: string[] }) {
  const { navigate, t, handleAlertClose, handleAlertValidate, alertClasses } = useAlert('userScopesWarning');

  const PathRoute = useRoutepaths();

  const handleAlertAction = useCallback(() => {
    handleAlertClose();
    handleAlertValidate();
    navigate('/app/' + PathRoute.app.dashboardUsers);
  }, [navigate, handleAlertClose, handleAlertValidate, PathRoute.app.dashboardUsers]);

  return (
    <>
      {scopes.includes('support_user_management') && (
        <Alert
          title={t('pages.cores.warnings.reviewUsersRoles.title')}
          description={t('pages.cores.warnings.reviewUsersRoles.description')}
          isClosable
          variant="secondary"
          type="warning"
          onClose={handleAlertClose}
          className={alertClasses}
          action={{
            title: t('pages.cores.warnings.reviewUsersRoles.action'),
            onClick: handleAlertAction,
          }}
        />
      )}

      {scopes.includes('read_write') && !scopes.includes('support_user_management') && (
        <Alert
          title={t('pages.cores.warnings.roleUpdated.title')}
          description={t('pages.cores.warnings.roleUpdated.description')}
          isClosable
          variant="secondary"
          type="warning"
          onClose={handleAlertClose}
          className={alertClasses}
        />
      )}

      {!scopes.includes('read_write') && (
        <Alert
          title={t('pages.cores.warnings.newRoles.title')}
          description={t('pages.cores.warnings.newRoles.description')}
          isClosable
          variant="secondary"
          type="default"
          onClose={handleAlertClose}
          className={alertClasses}
        />
      )}
    </>
  );
}
